import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import fieldNames from '../constants/field-names';
import createMailValidator from '../validators/create-mail-validator';

const { InputGroupField } = designSystem;

function MailField({ control, onChange, onClick }) {
  const handleChange = useCallback(
    (value) => {
      onChange({
        fieldName: fieldNames.MAIL_REFERENCE,
        fieldValue: value,
      });
    },
    [onChange]
  );

  const handleClick = useCallback(() => {
    onClick({ fieldName: fieldNames.MAIL_REFERENCE });
  }, [onClick]);

  return (
    <InputGroupField
      name={fieldNames.MAIL_REFERENCE}
      control={control}
      placeholder="example@email.com"
      rules={{ validate: createMailValidator() }}
      onChange={handleChange}
      onClick={handleClick}
    />
  );
}

MailField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MailField;
